import ScrollReveal from "../ScrollReveal";
import { PROCESS_STEPS } from "../../data/content";

export const Process = () => {
  return (
    <section
      data-testid="process-section"
      className="relative py-24 md:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <ScrollReveal className="mb-14 md:mb-20 max-w-2xl">
          <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-4">
            / Our Process
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight leading-[1]">
            How we forge<br /><span className="text-white/40">obsidian-grade work.</span>
          </h2>
        </ScrollReveal>

        <div className="relative grid md:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {PROCESS_STEPS.map((step, i) => (
            <ScrollReveal
              key={step.num}
              delay={i * 0.08}
              className="bg-[#080808] p-8 md:p-10 min-h-[280px] flex flex-col justify-between group hover:bg-[#0e0e0e] transition-colors"
            >
              <div>
                <div className="font-display text-5xl md:text-6xl font-black text-white/15 group-hover:text-white/40 transition-colors">
                  {step.num}
                </div>
                <h3
                  className="font-display text-xl md:text-2xl font-extrabold uppercase tracking-tight mt-6"
                  data-testid={`process-step-${i}`}
                >
                  {step.title}
                </h3>
              </div>
              <p className="text-sm text-white/55 leading-relaxed mt-6">
                {step.body}
              </p>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
